import { render, staticRenderFns } from "./campaignTraceConfig.vue?vue&type=template&id=134794a5&scoped=true"
import script from "./campaignTraceConfig.vue?vue&type=script&lang=js"
export * from "./campaignTraceConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134794a5",
  null
  
)

export default component.exports